import React from 'react';
import WhatsNewButton from './WhatsNewButton.tsx';

export default function WhatsNewButtonComp(props) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <WhatsNewButton {...props} />;
}
